/**
 * (c) 2021, Nous Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import {ProtocolRequestType} from "vscode-languageserver-protocol";
import {MarkupKind} from "vscode-languageserver-types";
import {LanguageServerClient} from "./client";

// This duplicates the types we added to Pyright.

export interface ExtensionsDocsParams {
    modules: string[];
    path: string;
    documentationFormat?: MarkupKind[];
}

export interface ExtensionsDocsBaseClass {
    name: string;
    fullName: string;
}

export type ExtensionsDocsFunctionParameterCategory =
    | "simple"
    | "varargList"
    | "varargDict";

export interface ExtensionsDocsFunctionParameter {
    name: string;
    category: ExtensionsDocsFunctionParameterCategory;
    defaultValue?: string;
}

export interface ExtensionsDocsEntry {
    id: string;
    name: string;
    docString?: string;
    fullName: string;
    type?: string;
    kind: "function" | "module" | "class" | "variable";
    children?: ExtensionsDocsEntry[];
    baseClasses?: ExtensionsDocsBaseClass[];
    params?: ExtensionsDocsFunctionParameter[];
}

export interface ExtensionsDocsResponse extends Record<string, ExtensionsDocsEntry> {
}

export const extensionsDocsRequestType = new ProtocolRequestType<
    ExtensionsDocsParams,
    ExtensionsDocsResponse,
    never,
    void,
    void
>("pyright/apidocs");

export const extensionsDocs = (
    client: LanguageServerClient,
    keyList
): Promise<ExtensionsDocsResponse> => {
    return client.connection.sendRequest(extensionsDocsRequestType, {
      path: client.rootUri,
      documentationFormat: [MarkupKind.Markdown],
      modules: [
        // 'AI',
        // "IoT",
        // "Bluetooth_Controller",
        // "Matata_Arcade",
        "extention.lego_motor",
        "extention.dc_motor",
        "extention.servo",
        "extention.joystick",
        "extention.led_strip",
        "extention.rotary_angle_sensor",
        "extention.temperature_humidity_sensor",
        "extention.servo360",
        "extention.pins",
        "extention.ports",
      ],
    });
};
